




















































import { Component, Vue } from 'vue-property-decorator';
import { DocumentRequestVisitReservationRequestList } from "@/common/ts/DocumentRequestVisitReservationRequestList";
import { SearchSession } from "@/common/ts/_SearchSession";
import { stickyOrderListView } from "@/pc/ts/components/_FacilitySearchRequestList";
import $ from "jquery";

@Component
export default class App extends Vue {
  contactTel!: string;
  facilityRequests!: DocumentRequestVisitReservationRequestList;

  constructor() {
    super();
    this.contactTel = document.getElementById('js-data')?.dataset?.contactTel || '';
    this.facilityRequests = new DocumentRequestVisitReservationRequestList();

    $<HTMLAnchorElement>('.js-visit-reservation').on('click', (ev) => {
      const target = $(ev.currentTarget);
      const facilityId = target.data('facilityId') as number;
      const facilityName = target.data('facilityName') as string;
      this.update(facilityId, facilityName, 'visit-reservation');
    });

    $<HTMLAnchorElement>('.js-document-request').on('click', (ev) => {
      const target = $(ev.currentTarget);
      const facilityId = target.data('facilityId') as number;
      const facilityName = target.data('facilityName') as string;
      this.update(facilityId, facilityName, 'document');
    });

    $<HTMLAnchorElement>('.js-list-add-close').on('click', () => {
      this.hideListAddModal();
    });

    $<HTMLAnchorElement>('.js-list-remove-cancel').on('click', () => {
      this.hideListRemoveModal();
    });

    $<HTMLAnchorElement>('.js-list-add-error').on('click', () => {
      this.hideListAddErrorModal();
    });
  }

  async mounted(): Promise<void> {
    await this.facilityRequests.init();
    this.facilityRequests.value.forEach(f => {
      if (f.isRequestVisit) {
        $(`.js-visit-reservation[data-facility-id=${f.facilityId}]`).addClass("active");
      }
      if (f.isRequestDocument) {
        $(`.js-document-request[data-facility-id=${f.facilityId}]`).addClass("active");
      }
    })
    stickyOrderListView();
  }

  update(facilityId: number, facilityName: string, type: 'document' | 'visit-reservation'): void {
    const fq = this.facilityRequests.value.find(f => f.facilityId === facilityId);

    const updateClassTarget = (() => {
      switch (type) {
        case "visit-reservation":
          return $(`.js-visit-reservation[data-facility-id=${facilityId}]`);
        case "document":
          return $(`.js-document-request[data-facility-id=${facilityId}]`);
      }
    })();

    const onClickOkButtonEvent = (): void => {
      if ($('.js-list-add-disable-notification').prop('checked') as boolean) {
        SearchSession.set('isShowableNotification', false);
      }
      this.hideListAddModal();
    }

    if (!fq) {
      if (this.facilityRequests.value.length >= 10) {
        this.showListAddErrorModal();
        return;
      }

      this.facilityRequests.add({
        facilityId: facilityId,
        name: facilityName,
        isRequestVisit: type === 'visit-reservation',
        isRequestDocument: type === 'document',
        lastUpdatedAt: Math.floor(new Date().getTime() / 1000)
      });
      updateClassTarget.addClass('active');
      if (SearchSession.get('isShowableNotification')) {
        this.showListAddModal(facilityName, onClickOkButtonEvent);
      }
      return;
    }

    switch (type) {
      case "visit-reservation":
        fq.isRequestVisit = !fq.isRequestVisit;
        this.facilityRequests.update(fq);
        if (fq.isRequestVisit) {
          updateClassTarget.addClass('active');
          if (SearchSession.get('isShowableNotification')) {
            this.showListAddModal(facilityName, onClickOkButtonEvent);
          }
        } else {
          updateClassTarget.removeClass('active');
        }
        return;
      case "document":
        fq.isRequestDocument = !fq.isRequestDocument;
        this.facilityRequests.update(fq);
        if (fq.isRequestDocument) {
          updateClassTarget.addClass('active');
          if (SearchSession.get('isShowableNotification')) {
            this.showListAddModal(facilityName, onClickOkButtonEvent);
          }
        } else {
          updateClassTarget.removeClass('active');
        }
        return;
    }
  }

  remove(facilityId: number, facilityName: string): void {
    const onClickOkButtonEvent = () => {
      $(`.js-visit-reservation[data-facility-id=${facilityId}]`).removeClass('active');
      $(`.js-document-request[data-facility-id=${facilityId}]`).removeClass('active');
      this.facilityRequests.remove(facilityId);
      this.hideListRemoveModal();
       $(".js-list-remove-done").show();
    setTimeout(function(){
      $(".js-list-remove-done").fadeOut();
    },1300);
    }
    this.showListRemoveModal(facilityName, onClickOkButtonEvent);
  }

  showListAddModal(facilityName: string, onClickOkButtonEvent: any): void {
    $('.js-list-add-facility-name').text(facilityName);
    $('.js-list-add-disable-notification').prop('checked', false);
    $('.js-list-add-ok').off('click').on('click', onClickOkButtonEvent);
    $(".js-list-add").show();
    setTimeout(function(){
      $(".js-list-add").fadeOut();
    },1300);
  }

  hideListAddModal(): void {
    $(".js-list-add").hide();
  }

  showListRemoveModal(facilityName: string, onClickOkButtonEvent: any): void {
    $('.js-list-remove-facility-name').text(facilityName);
    $('.js-list-remove-ok').off('click').on('click', onClickOkButtonEvent);
    $(".js-list-remove").show();
  }

  hideListRemoveModal(): void {
    $(".js-list-remove").hide();
  }

  showListAddErrorModal(): void {
    $(".js-list-add-error").show();
  }

  hideListAddErrorModal(): void {
    $(".js-list-add-error").hide();
  }

  submit(): void {
    const href = new URL(window.location.href);
    const isFromDiagnosis = href.searchParams.has('qt1');

    // "qt" で始まるクエリパラメータを抽出
    const qtParams: Record<string, string> = {};
      href.searchParams.forEach((value, key) => {
      if (key.startsWith('qt')) {
        qtParams[key] = value;
      }
    });
    const qtQueryString = new URLSearchParams(qtParams).toString();
    //　診断コンテンツから遷移してきた場合は、診断内容を引き継ぐ
    if (isFromDiagnosis) {
      location.href = `/step/snr_step/step1.html?${qtQueryString}`;
    } else {
      location.href = '/step/snr_step/step1.html';
    }
    
  }
}
